import axios from 'axios';
import { useService } from '../common/useService';
import { AnalyticsEventDto } from './analytics-event.dto';

const useSendAnalyticsEvent = () =>
  useService((data: AnalyticsEventDto) => {
    return axios.post('/my-account-api/event/send-analytics-event.php', data);
  });

const EventService = {
  useSendAnalyticsEvent,
};

export default EventService;
